import { useState } from 'react';

export const useInstance = <T>(fabric: () => T) => {
  const [inst] = useState<T>(fabric);

  return inst;
};
